module.exports = __webpack_public_path__ + "static/media/toc-mockup-5.3072d29b.jpg";